const LOCK_COUNT_KEY = 'cap4ScrollLockCount';
const PREVIOUS_OVERFLOW_KEY = 'cap4ScrollLockPreviousOverflow';

function getLockCount(body: HTMLElement) {
  const raw = body.dataset[LOCK_COUNT_KEY];
  const count = raw ? Number.parseInt(raw, 10) : 0;
  return Number.isFinite(count) && count > 0 ? count : 0;
}

function setLockCount(body: HTMLElement, count: number) {
  if (count > 0) {
    body.dataset[LOCK_COUNT_KEY] = String(count);
    return;
  }

  delete body.dataset[LOCK_COUNT_KEY];
}

/**
 * Acquire a shared body scroll lock and return an idempotent release callback.
 *
 * Multiple overlays can mount/unmount in any order; the body's original inline
 * overflow is restored only after the final active lock releases.
 */
export function acquireBodyScrollLock(doc: Document = document) {
  const { body } = doc;
  let released = false;
  const count = getLockCount(body);

  if (count === 0) {
    body.dataset[PREVIOUS_OVERFLOW_KEY] = body.style.overflow;
  }

  setLockCount(body, count + 1);
  body.style.overflow = 'hidden';

  return () => {
    if (released) return;
    released = true;

    const remaining = getLockCount(body) - 1;
    if (remaining > 0) {
      setLockCount(body, remaining);
      body.style.overflow = 'hidden';
      return;
    }

    const previousOverflow = body.dataset[PREVIOUS_OVERFLOW_KEY] ?? '';
    body.style.overflow = previousOverflow;
    delete body.dataset[PREVIOUS_OVERFLOW_KEY];
    setLockCount(body, 0);
  };
}
